// Styles
import "@mdi/font/css/materialdesignicons.css"; // Importieren der Material Design Icons
import "vuetify/styles"; // Importieren der Vuetify-Styles

// Vuetify
import { createVuetify } from "vuetify";

// Erstellen und Exportieren der Vuetify-Instanz mit der Konfiguration
export default createVuetify({
  theme: {
    defaultTheme: "light", // Standard-Theme setzen
    themes: {
      light: {
        colors: {
          primary: "#2196f3", // Primärfarbe hier einstellen
          secondary: "#FF385C", // Airbnb-style accent
          // Fügen Sie hier weitere Farbanpassungen hinzu
        },
      },
      dark: {
        colors: {
          primary: "#BBDEFB", // Primärfarbe für den Dunkelmodus
          // Fügen Sie hier weitere Farbanpassungen hinzu
        },
      },
    },
  },
  // Display-Breakpoints für responsive Design
  display: {
    mobileBreakpoint: 'md',
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  // Defaults für bessere mobile UX
  defaults: {
    VBtn: {
      style: 'text-transform: none;',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VDialog: {
      scrollable: true,
    },
  },
});
